import { formatDate } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import { toKebabCase } from '../../../../../utils/helpers/string'
import { usePublicToken } from '../../_load/PublicTokenLoader'
import { useSubdomain } from '../../../../../utils/contexts/UrlProvider'
import LabelValue from '../../../../../packages/kiti/components/presentation/LabelValue'
import Panel from '../../../../../packages/kiti/components/structure/Panel'
import Text, { SmallText } from '../../../../../packages/kiti/components/presentation/Text'

const Details = () => {
  const { t } = useTranslation('publicToken')
  const publicToken = usePublicToken()
  const workspace = useSubdomain()
  const url = `https://api.btime.io/new/public-api/${workspace}/${toKebabCase(publicToken.action)}/${publicToken.token}`

  return (
    <Grid justify="flex-start" align="flex-start" paddingGutter={0.5} wrap>
      <Col width="50%">
        <LabelValue
          label={t('remainingUses')}
          value={publicToken.amountLeft ? t('calls', { count: publicToken.amountLeft }) : t('noLimit')}
        />
      </Col>

      <Col width="50%">
        <LabelValue
          label={t('expireDate')}
          value={publicToken.expireDate ? formatDate(publicToken.expireDate) : t('noExpireDate')}
        />
      </Col>

      <Col width="100%">
        <SmallText size="xsmall" color="dark4">
          {t('publicUrl')}
        </SmallText>

        <Panel padding={0.5} bgColor="dark2">
          <Text color="white">{url}</Text>
        </Panel>
      </Col>

      <Col width="100%">
        <SmallText size="xsmall" color="dark4">
          {t('conditions')}
        </SmallText>

        <Panel padding={0.5} bgColor="light1">
          <Text>
            <pre>
              <code>{JSON.stringify(publicToken.conditions, null, 4)}</code>
            </pre>
          </Text>
        </Panel>
      </Col>

      <Col width="100%">
        <SmallText size="xsmall" color="dark4">
          {t('payload')}
        </SmallText>

        <Panel padding={0.5} bgColor="light1">
          <Text>
            <pre>
              <code>{JSON.stringify(publicToken.payload, null, 4)}</code>
            </pre>
          </Text>
        </Panel>
      </Col>
    </Grid>
  )
}

export default Details
